import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/analytics-1.4-apis/analytics-1.4-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const CodeBlock = makeShortcode("CodeBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "14-reporting-api-methods"
    }}>{`1.4 Reporting API methods`}</h1>
    <p>{`Methods that you can call within the 1.4 Reporting API.`}</p>
    <h2 {...{
      "id": "queue"
    }}>{`Queue`}</h2>
    <p>{`Queue a report to run. You can queue up multiple reports to run concurrently.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.Queue`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.Queue" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportDescription":{"reportSuiteID": "examplersid"}}'
`}</code></pre>
    <h4 {...{
      "id": "response"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "reportID": 1234567890
}
`}</code></pre>
    <p>{`This method requires a `}<inlineCode parentName="p">{`reportDescription`}</inlineCode>{` JSON object, which contains the desired reporting parameters. See `}<a parentName="p" {...{
        "href": "report-description/index.md"
      }}>{`reportDescription JSON object reference`}</a>{` for details.`}</p>
    <p>{`The response contains a report ID - use this report ID in the `}<inlineCode parentName="p">{`Report.Get`}</inlineCode>{` method to retrieve the report.`}</p>
    <h2 {...{
      "id": "get"
    }}>{`Get`}</h2>
    <p>{`Retrieves a report queued using `}<inlineCode parentName="p">{`Report.Queue`}</inlineCode>{`. As a best practice, Do not call this method more than once a second.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.Get`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-1"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.Get" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportID": 1234567890}'
`}</code></pre>
    <h4 {...{
      "id": "response-1"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "report": {
        "type": "overtime",
        "elements": [
            {
                "id": "datetime",
                "name": "Date"
            }
        ],
        "reportSuite": {
            "id": "examplersid",
            "name": "Example report suite"
        },
        "period": "Thu. 19 Jan. YYYY",
        "metrics": [
            {
                "id": "pageviews",
                "name": "Page Views",
                "type": "number",
                "decimals": 0,
                "latency": 1427,
                "current": false
            }
        ],
        "data": [
            {
                "name": "Thu. 19 Jan. YYYY",
                "month": 1,
                "day": 19,
                "counts": [
                    "291745"
                ]
            }
        ],
        "totals": [
            "291745"
        ],
        "version": "1.4.18.10"
    },
    "waitSeconds": 0,
    "runSeconds": 0
}
`}</code></pre>
    <p>{`This method requires a JSON body, which includes the report ID to retrieve. You can obtain a report ID using `}<inlineCode parentName="p">{`Report.Queue`}</inlineCode>{`.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Request element`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportID`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Report ID returned by `}<inlineCode parentName="td">{`Report.Queue`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`page`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Desired page number (out of `}<inlineCode parentName="td">{`totalPages`}</inlineCode>{`) for larger `}<a parentName="td" {...{
              "href": "data_warehouse.md"
            }}>{`Data Warehouse`}</a>{` requests.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns a JSON object containing the desired report data. See `}<a parentName="p" {...{
        "href": "report-data.md"
      }}>{`Report data object reference`}</a>{` for details.`}</p>
    <p>{`If the report is not ready, a `}<inlineCode parentName="p">{`HTTP 400`}</inlineCode>{` error is returned.`}</p>
    <h2 {...{
      "id": "cancel"
    }}>{`Cancel`}</h2>
    <p>{`Cancels a previously submitted report request, removing it from the processing queue. You can only cancel reports that are queued or running; if you send a request to cancel a completed report, the API returns an error.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.Cancel`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-2"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.Cancel" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportID": 1234567890}'
`}</code></pre>
    <h4 {...{
      "id": "response-2"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`true
`}</code></pre>
    <p>{`This method requires a JSON body, which includes the report ID to retrieve. You can obtain a report ID using `}<inlineCode parentName="p">{`Report.Queue`}</inlineCode>{`.`}</p>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` is the operation is successful.`}</p>
    <h2 {...{
      "id": "getelements"
    }}>{`GetElements`}</h2>
    <p>{`Retrieves a list of valid `}<a parentName="p" {...{
        "href": "report-description/dimensions.md"
      }}>{`dimensions`}</a>{` for the user. Some users might not have access to certain dimensions, so you can use this method to retrieve the dimensions that you can access.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.GetElements`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-3"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.GetElements" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportSuiteID": "examplersid"}'
`}</code></pre>
    <h4 {...{
      "id": "response-3"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
    {
        "id": "accountsummary",
        "name": "Report Suite Totals",
        "correlation": true,
        "subrelation": false
    },
    {
        "id": "activity",
        "name": "Activity",
        "correlation": false,
        "subrelation": true
    },
    {
        "id": "browser",
        "name": "Browser",
        "correlation": true,
        "subrelation": true
    },
    {
        "id": "browserheight",
        "name": "Browser Height",
        "correlation": true,
        "subrelation": true
    }
]
`}</code></pre>
    <p>{`This request requires a JSON body, which includes the report suite ID to obtain accessible dimensions.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Request element`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportSuiteID`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The report suite ID that you want to list accessible dimensions for.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`existingElements`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Include a list of elements already present in the reportDescription to get compatible metrics.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`existingMetrics`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Include a list of metrics already present in the reportDescription to get compatible metrics.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportType`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Include the report type to get compatible metrics. Valid values include `}<inlineCode parentName="td">{`any`}</inlineCode>{`, `}<inlineCode parentName="td">{`ranked`}</inlineCode>{`, `}<inlineCode parentName="td">{`trended`}</inlineCode>{`, `}<inlineCode parentName="td">{`pathing`}</inlineCode>{`, `}<inlineCode parentName="td">{`fallout`}</inlineCode>{`, and `}<inlineCode parentName="td">{`realtime`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns a list of dimensions that the user can access. Each dimension contains the following elements:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Response element`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`id`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The dimension ID.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The dimension name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`correlation`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines if the dimension supports correlations. Used in previous versions of Adobe Analytics.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`subrelation`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`boolean`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Determines if the dimension supports subrelations. Used in previous versions of Adobe Analytics.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "getmetrics"
    }}>{`GetMetrics`}</h2>
    <p>{`Retrieves a list of valid `}<a parentName="p" {...{
        "href": "report-description/metrics.md"
      }}>{`metrics`}</a>{` for the user. Some users might not have access to certain metrics, so you can use this method to retrieve the dimensions that you can access.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.GetMetrics`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-4"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.GetMetrics" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportSuiteID": "examplersid"}'
`}</code></pre>
    <h4 {...{
      "id": "response-4"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
    {
        "id": "activityimpressions",
        "name": "Activity Impressions",
        "type": "number",
        "decimals": 0,
        "formula": null
    },
    {
        "id": "averagevisitdepth",
        "name": "Average Visit Depth",
        "type": "number",
        "decimals": 0,
        "formula": null
    },
    {
        "id": "bouncerate",
        "name": "Bounce Rate",
        "type": "percent",
        "decimals": 10,
        "formula": null
    }
]
`}</code></pre>
    <p>{`This request requires a JSON body, which includes the report suite ID to obtain accessible metrics.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportSuiteID`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The report suite ID that you want to list accessible metrics for.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`existingElements`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Include a list of elements already present in the reportDescription to get compatible metrics.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`existingMetrics`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string[]`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Include a list of metrics already present in the reportDescription to get compatible metrics.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportType`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`(Optional) Include the report type to get compatible metrics. Valid values include `}<inlineCode parentName="td">{`any`}</inlineCode>{`, `}<inlineCode parentName="td">{`ranked`}</inlineCode>{`, `}<inlineCode parentName="td">{`trended`}</inlineCode>{`, `}<inlineCode parentName="td">{`pathing`}</inlineCode>{`, `}<inlineCode parentName="td">{`fallout`}</inlineCode>{`, and `}<inlineCode parentName="td">{`realtime`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Returns a list of metrics that the user can access. Each metric contains the following elements:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Response element`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`id`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The metric ID.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`name`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The metric name.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`type`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The metric type. Valid values include `}<inlineCode parentName="td">{`number`}</inlineCode>{`, `}<inlineCode parentName="td">{`percent`}</inlineCode>{`, `}<inlineCode parentName="td">{`currency`}</inlineCode>{`, and `}<inlineCode parentName="td">{`time`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`decimals`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The number of decimal places that the metric uses.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`formula`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`null`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The formula if the metric is a calculated metric.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "getqueue"
    }}>{`GetQueue`}</h2>
    <p>{`Returns a list of reports in a company's report queue.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.GetQueue`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-5"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X GET "https://api.omniture.com/admin/1.4/rest/?method=Report.GetQueue" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
`}</code></pre>
    <h4 {...{
      "id": "response-5"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`[
    {
        "reportID": 1234567890,
        "type": "tr",
        "queueTime": "YYYY-06-29T16:41:53-0800",
        "status": "running",
        "priority": 0,
        "estimate": 899.8214212508286,
        "reportSuiteID": "examplersid",
        "user": "exampleuser"
    },
    {
        "reportID": 1234567891,
        "type": "tr",
        "queueTime": "YYYY-06-29T16:42:09-0800",
        "status": "running",
        "priority": 0,
        "estimate": 256.4867531674,
        "reportSuiteID": "examplersid",
        "user": "exampleuser2"
    }
]
`}</code></pre>
    <p>{`Does not require a JSON body. Returns a list of reports currently running for the company. Company is determined by the credentials used in the `}<inlineCode parentName="p">{`x-api-key`}</inlineCode>{` and `}<inlineCode parentName="p">{`Authorization`}</inlineCode>{` headers.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Response element`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportID`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The report ID running.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`type`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The type of report. Valid values include `}<inlineCode parentName="td">{`ot`}</inlineCode>{` (overtime report), `}<inlineCode parentName="td">{`ra`}</inlineCode>{` (ranked report), `}<inlineCode parentName="td">{`tr`}</inlineCode>{` (trended report), `}<inlineCode parentName="td">{`pa`}</inlineCode>{` (pathing report), `}<inlineCode parentName="td">{`fo`}</inlineCode>{` (fallout report), `}<inlineCode parentName="td">{`rt`}</inlineCode>{` (realtime report), `}<inlineCode parentName="td">{`su`}</inlineCode>{` (summary report).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`queueTime`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`date`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The date/time that the report was queued (Pacific time).`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`status`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The status of the report. Valid values include `}<inlineCode parentName="td">{`waiting`}</inlineCode>{` or `}<inlineCode parentName="td">{`running`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`priority`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`int`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The report priority.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`estimate`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`double`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The estimated time remaining (in seconds) before the report is complete.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`reportSuiteID`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The report suite ID of the report.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td"><inlineCode parentName="strong">{`user`}</inlineCode></strong></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The user that requested the report.`}</td>
        </tr>
      </tbody>
    </table>
    <h2 {...{
      "id": "retry"
    }}>{`Retry`}</h2>
    <p>{`Retries a report that either has failed running or you want to run again. Convenience method that saves trouble of submitting again a full request via `}<inlineCode parentName="p">{`Report.Queue`}</inlineCode>{`.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.Run`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-6"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.Run" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportID": 1234567890}}'
`}</code></pre>
    <h4 {...{
      "id": "response-6"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`true
`}</code></pre>
    <p>{`This method requires a JSON body, which includes the report ID to retrieve. You can obtain a report ID using `}<inlineCode parentName="p">{`Report.Queue`}</inlineCode>{`.`}</p>
    <p>{`Returns `}<inlineCode parentName="p">{`true`}</inlineCode>{` is the operation is successful.`}</p>
    <h2 {...{
      "id": "run"
    }}>{`Run`}</h2>
    <p>{`Run a real-time report immediately without using the queue.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.Run`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-7"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.Run" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{"reportDescription":{"reportSuiteID": "examplersid","source": "realtime"}}'
`}</code></pre>
    <h4 {...{
      "id": "response-7"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "report": {
        "type": "realtime",
        "reportSuite": {
            "id": "examplersid",
            "name": "Example report suite"
        },
        "period": "YYYY-03-30T16:30:04-0800/YYYY-03-30T17:30:04-0800",
        "elements": [
            {
                "id": "datetime",
                "name": "Date"
            }
        ],
        "metrics": [
            {
                "id": "instances",
                "name": "Instances",
                "type": "number",
                "decimals": 0
            }
        ],
        "data": [
            {
                "name": "YYYY-01-19T16:30:04-0800",
                "month": 3,
                "day": 30,
                "hour": 16,
                "minute": 30,
                "counts": [
                    "1415718"
                ]
            },
            {
                "name": "YYYY-01-19T16:35:04-0800",
                "month": 3,
                "day": 30,
                "hour": 16,
                "minute": 35,
                "counts": [
                    "1394239"
                ]
            },
            {
                "name": "YYYY-01-19T16:40:04-0800",
                "month": 3,
                "day": 30,
                "hour": 16,
                "minute": 40,
                "counts": [
                    "1394988"
                ]
            }
        ],
        "totals": [
            "16356302"
        ],
        "version": "1.4.18.10",
        "__run_time_frag": 0.26024293899536133
    }
}
`}</code></pre>
    <p>{`This method requires a `}<inlineCode parentName="p">{`reportDescription`}</inlineCode>{` JSON object, which contains the desired reporting parameters. See `}<a parentName="p" {...{
        "href": "report-description/index.md"
      }}>{`reportDescription JSON object reference`}</a>{` for details. The `}<inlineCode parentName="p">{`source`}</inlineCode>{` element must be set to `}<inlineCode parentName="p">{`realtime`}</inlineCode>{` for this API call to work.`}</p>
    <p>{`Returns a JSON object containing the desired report data. See `}<a parentName="p" {...{
        "href": "report-data.md"
      }}>{`Report data object reference`}</a>{` for details.`}</p>
    <h2 {...{
      "id": "validate"
    }}>{`Validate`}</h2>
    <p>{`Determines if a `}<inlineCode parentName="p">{`reportDescription`}</inlineCode>{` object is valid without running the report. If the report is not valid, an error is returned detailing the problem.`}</p>
    <p><strong parentName="p"><inlineCode parentName="strong">{`POST https://api.omniture.com/admin/1.4/rest/?method=Report.Validate`}</inlineCode></strong></p>
    <CodeBlock slots="heading, code" repeat="2" languages="CURL,JSON" mdxType="CodeBlock" />
    <h4 {...{
      "id": "request-8"
    }}>{`Request`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-sh"
      }}>{`curl -X POST "https://api.omniture.com/admin/1.4/rest/?method=Report.Validate" \\
    -H "x-api-key: {CLIENTID}" \\
    -H "Authorization: Bearer {ACCESSTOKEN}" \\
    -H "Content-Type: application/json" \\
    -d '{
    "reportDescription": {
        "reportSuiteID": "examplersid",
        "source": "standard",
        "dateFrom": "now",
        "dateTo": "noon",
        "metrics": [
            {
                "id": "pageviews"
            }
        ],
        "locale": "en_US",
        "dateGranularity": "minute:30",
        "currentData": false
    }
}'
`}</code></pre>
    <h4 {...{
      "id": "response-8"
    }}>{`Response`}</h4>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
    "valid": true
}
`}</code></pre>
    <p>{`This method requires a `}<inlineCode parentName="p">{`reportDescription`}</inlineCode>{` JSON object, which contains the desired reporting parameters. See `}<a parentName="p" {...{
        "href": "report-description/index.md"
      }}>{`reportDescription JSON object reference`}</a>{` for details.`}</p>
    <ul>
      <li parentName="ul">{`If the `}<inlineCode parentName="li">{`reportDescription`}</inlineCode>{` JSON object is valid, the response contains `}<inlineCode parentName="li">{`"valid": true`}</inlineCode>{`.`}</li>
      <li parentName="ul">{`If the `}<inlineCode parentName="li">{`reportDescription`}</inlineCode>{` JSON object is invalid, the API returns an error outlining the issue. See `}<a parentName="li" {...{
          "href": "troubleshooting.md"
        }}>{`Troubleshooting`}</a>{` for details. `}</li>
      <li parentName="ul">{`If `}<inlineCode parentName="li">{`source`}</inlineCode>{` is set to `}<inlineCode parentName="li">{`realtime`}</inlineCode>{`, ensure either `}<inlineCode parentName="li">{`currentData`}</inlineCode>{` is set to `}<inlineCode parentName="li">{`false`}</inlineCode>{` or `}<inlineCode parentName="li">{`currentData`}</inlineCode>{` is not part of the request, otherwise a 500 - Internal Server Error is returned.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      